import { ReactComponent as NewFireIcon } from 'assets/svg/new_fireicon_red.svg'
import { ReactComponent as NewLightIcon } from 'assets/svg/new_lightIcon.svg'
import React from 'react'
import styled from 'styled-components'
import ArrowRightDropdownItem from '../../../../../../assets/svg/ArrowRightDropdownItem'
import { GATSBY_MAIN_URL } from '../../../../../../constants/env'
import useCollaterals from '../../../../../../hooks/useCollaterals'
import useLocale from '../../../../../../hooks/useLocale'
import { useLeadersQuery } from '../../../../../../queries'
import { DropdownCopytradingTopTradersList } from './DropdownCopytradingTopTradersList'

export const DropdownCopytradingTopTraders = () => {
  const collaterals = useCollaterals()
  const collteralsWithoutAirUSDT = collaterals?.filter(item => item.asset !== 'AIR_USDT')?.map(item => item.id)

  const { data: leadersResponse, isLoading } = useLeadersQuery({
    options: { staleTime: Infinity, enabled: Boolean(collteralsWithoutAirUSDT?.length) },
    copytradingLeadersParams: {
      max: 10,
      offset: 0,
      filters: { roe: 'ALL', collateralIds: collteralsWithoutAirUSDT },
      sort: 'RATING_ASC',
    },
  })

  const { pammAccountResponseList: traders = [] } = leadersResponse || {}
  const { locale } = useLocale()
  const discoverAllPath =
    locale === 'en' ? `${GATSBY_MAIN_URL}/page/copytrading` : `${GATSBY_MAIN_URL}/page/${locale}/copytrading`

  return (
    <StyledDropdownCopytradingTopTraders>
      <Header>
        <HeaderText>Our Top 3 Traders</HeaderText> <NewFireIcon />
      </Header>
      <DropdownCopytradingTopTradersList traders={traders} isLoading={isLoading} />
      <Footer rel='noopener noreferrer' href={discoverAllPath}>
        <DiscoverAllContainer>
          <LightIcon />
          Discover All Traders
        </DiscoverAllContainer>
        <ArrowRight />
      </Footer>
    </StyledDropdownCopytradingTopTraders>
  )
}

const StyledDropdownCopytradingTopTraders = styled.div`
  width: 341.5px;
  height: 100%;
  padding: 32px 18px 16px 32px;
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #324875;
  display: flex;
  align-items: center;
  gap: 4px;
`

const HeaderText = styled.span`
  margin-inline-start: 12px;
  font-family: 'Gilroy';
`

const Footer = styled.a`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3071ee;
  display: flex;
  gap: 24px;
  margin: auto;
`

const ArrowRight = styled(ArrowRightDropdownItem)`
  width: 16px;
  stroke: #3071ee;
`

const DiscoverAllContainer = styled.span`
  display: flex;
  align-items: flex-start;
  gap: 2px;
`

const LightIcon = styled(NewLightIcon)`
  stroke: #3071ee;
  width: 24px;
  height: 24px;

  path {
    fill: #3071ee;
  }
`
